import fetchClient from '../components/common/FetchClient';
import { isNullOrUndefined } from 'util';

const requestOrderPlannerDeliveryModesType = 'REQUEST_ORDERPLANNER_DELIVERY_MODE';
const receiveOrderPlannerDeliveryModesType = 'RECEIVE_ORDERPLANNER_DELIVERY_MODE';

const receiveOrderPlannerDeliveryDatesType = 'RECEIVE_ORDERPLANNER_DELIVERY_DATES';

const setOrderPlannerDeliveryDateType = 'SET_ORDERPLANNER_DELIVERY_DATE';
const setOrderPlannerDeliveryModeType = 'SET_ORDERPLANNER_DELIVERY_MODE';

const requestOrderPlannerUniquePOType = 'REQUEST_ORDERPLANNER_UNIQUE_PO_MODE';
const receiveOrderPlannerUniquePOType = 'RECEIVE_ORDERPLANNER_UNIQUE_PO_MODE';

//const requestOrderPlannerDeliveryModeDatesType = 'REQUEST_ORDERPLANNER_DELIVERY_MODE_DATES';
//const receiveOrderPlannerDeliveryModeDatesType = 'RECEIVE_ORDERPLANNER_DELIVERY_MODE_DATES';

// eslint-disable-next-line
function isInDateArray(array, value) {
    return !!array.find(item => { return item.getTime() == value.getTime() });
}

const initialState = {
    deliveryModes: [],
    deliveryModeDates: [],
    selectedDeliveryMode: '',
    selectedDeliveryDate: localStorage.getItem('deliveryDate') ? Date.parse(localStorage.getItem('deliveryDate').replace(/-/g, "/")) : undefined,
    selectedDeliveryModeCode: '',
    validUniquePO: isNullOrUndefined(localStorage.getItem('badPO')) ? true : Boolean(localStorage.getItem('badPO')) === true,
    requirePO: localStorage.getItem('requirePO') === 'true',
    uniquePO: localStorage.getItem('requireUniquePO') === 'true',
};

export const actionCreators = {
    selectDeliveryDate: date => async (dispatch, getState) => {
        var newDate = new Date(date);
        newDate = new Date(newDate.getTime() - newDate.getTimezoneOffset() * -60000);

        localStorage.setItem('deliveryDate', newDate);

        dispatch({ type: setOrderPlannerDeliveryDateType, newDate });
    }
    ,
    selectDeliveryMode: deliveryMode => async (dispatch, getState) => {
        localStorage.setItem('deliveryModeCode', deliveryMode.Code);
        localStorage.setItem('deliveryModeDescription', deliveryMode.Description);

        dispatch({ type: setOrderPlannerDeliveryModeType, deliveryMode });

        const url = `/api/OrderPlanner/DeliveryModesRequest`;

        fetchClient(url, {
            params: {
                azureToken: '',
                customerId: localStorage.getItem('customer'),
                addressId: localStorage.getItem('address'),
                dlvModeCode: deliveryMode.Code,
                isDlvModeReq: false
            }
        })
            .then(function (resp) {
                console.log('delivery mode id req',resp);
                if (resp) {

                    var deliveryDatesCSV = resp.data.DlvModeReqResp.DeliveryDates;
                    var deliveryModes = [];
                    var dateArray = [];
                    var includeDates = [];

                    dateArray = deliveryDatesCSV.split(',');

                    console.log('dateArray', dateArray);

                    dateArray.map((deliveryDate) => {
                        //  Safari & IE browsers do not support the date format “yyyy-mm-dd”
                        const fixDateForAllBrowsers = deliveryDate.replace(/-/g, "/");

                        var tmpDate = new Date(fixDateForAllBrowsers);

                        includeDates.push(new Date(tmpDate.getTime() - tmpDate.getTimezoneOffset() * -60000));
                        //includeDates.push(deliveryDate);

                        return '';
                    });
                    
                    var selectedDeliveryDate = includeDates[0];

                    localStorage.setItem('deliveryDate', selectedDeliveryDate);

                    dispatch({
                        type: receiveOrderPlannerDeliveryDatesType,
                        selectedDeliveryDate,
                        includeDates,
                        dateArray
                    });
                }
            });
    }
    ,
    queryOrderPlannerUniquePO: poNum => async (dispatch, getState) => {
        const url = `/api/OrderPlanner/IsDuplicatePO`;

        dispatch({ type: requestOrderPlannerUniquePOType });

        console.log('querying unique po...');
        fetchClient(url, {
            params: {
                azureToken: '',
                custAccount: localStorage.getItem('customer'),
                poNumber: poNum
            }
        })
            .then(function (resp) {
                if (resp) {
                    console.log('PO resp:', resp);
                    //if (resp.data.contains("Error")) {
                    //    // display error message
                    //}
                    var validUniquePO = resp.data === "No";
                    console.log('Valid PO?', validUniquePO);

                    if (validUniquePO === false) {
                        localStorage.setItem('badPO', true);
                        console.log('Setting Bad PO in local storage', localStorage.getItem('badPO'));
                        alert('This PO has been used before. Please enter a different PO.');
                    } else {
                        localStorage.removeItem('badPO');
                    }

                    dispatch({
                        type: receiveOrderPlannerUniquePOType,
                        validUniquePO
                    });
                }
            });
    }
    ,
    queryOrderPlannerDeliveryModes: isDeliveryScreen => async (dispatch, getState) => {

        console.log('delivery screen?', isDeliveryScreen);
        console.log('delivery date?', localStorage.getItem('deliveryDate'));

        dispatch({ type: requestOrderPlannerDeliveryModesType });

        const url = `/api/OrderPlanner/DeliveryModesRequest`;

        fetchClient(url, {
            params: {
                azureToken: '',
                customerId: localStorage.getItem('customer'),
                addressId: localStorage.getItem('address'),
                dlvModeCode: localStorage.getItem('deliveryModeCode'),
                isCalendarReq: false
            }})
            .then(function (resp) {
                console.log(resp);
                if (resp) {

                    var pullDatesForCode = false;
                    if (isNullOrUndefined(localStorage.getItem('deliveryModeCode')) === false) {
                        pullDatesForCode = true;
                    }
                    
                    var deliveryDatesCSV = resp.data.DlvModeReqResp.DeliveryDates;
                    var dateArray = [];
                    var includeDates = [];

                    var deliveryModes = [];

                    resp.data.DlvModeReqResp.DlvMode.map((deliveryMode) => {
                        deliveryModes.push(deliveryMode);

                        return '';
                    });

                    if (pullDatesForCode === true) {

                        var deliveryMode = {};
                        deliveryMode.Code = localStorage.getItem('deliveryModeCode');
                        deliveryMode.Description = localStorage.getItem('deliveryModeDescription');

                        console.log('deliveryMode', deliveryMode);

                        const url = `/api/OrderPlanner/DeliveryModesRequest`;

                        fetchClient(url, {
                            params: {
                                azureToken: '',
                                customerId: localStorage.getItem('customer'),
                                addressId: localStorage.getItem('address'),
                                dlvModeCode: deliveryMode.Code,
                                isDlvModeReq: false
                            }
                        }).then(function (resp) {
                            console.log('delivery mode id req', resp);
                            if (resp) {

                                var deliveryDatesCSV = resp.data.DlvModeReqResp.DeliveryDates;
                                dateArray = [];
                                includeDates = [];

                                dateArray = deliveryDatesCSV.split(',');

                                dateArray.map((deliveryDate) => {
                                    const fixDateForAllBrowsers = deliveryDate.replace(/-/g, "/");

                                    var tmpDate = new Date(fixDateForAllBrowsers);
                                    includeDates.push(new Date(tmpDate.getTime() - tmpDate.getTimezoneOffset() * -60000));
                                    //includeDates.push(deliveryDate);

                                    return '';
                                });

                                if (localStorage.getItem('deliveryDate')) {
                                    selectedDeliveryDate = localStorage.getItem('deliveryDate');
                                }

                                localStorage.setItem('deliveryDate', selectedDeliveryDate);

                                var selectedDeliveryDate = localStorage.getItem('deliveryDate') || includeDates[0];
                                if (isDeliveryScreen === true) {
                                    selectedDeliveryDate = includeDates[0];
                                }

                                if (isInDateArray(includeDates, (new Date(selectedDeliveryDate))) === false) {
                                    selectedDeliveryDate = includeDates[0];
                                }

                                var selectedDeliveryModeCode = localStorage.getItem('deliveryModeCode') || resp.data.DlvModeReqResp.DlvMode[0].Code;
                                var selectedDeliveryMode = localStorage.getItem('deliveryModeDescription') || resp.data.DlvModeReqResp.DlvMode[0].Description;

                                localStorage.setItem('deliveryDate', selectedDeliveryDate);
                                console.log('selected delivery date', selectedDeliveryDate);

                                dispatch({
                                    type: receiveOrderPlannerDeliveryModesType,
                                    selectedDeliveryMode,
                                    selectedDeliveryModeCode,
                                    selectedDeliveryDate,
                                    deliveryModes,
                                    includeDates,
                                    dateArray
                                });
                            }
                        });
                    } else {
                        dateArray = deliveryDatesCSV.split(',');

                        dateArray.map((deliveryDate) => {
                            const fixDateForAllBrowsers = deliveryDate.replace(/-/g, "/");

                            var tmpDate = new Date(fixDateForAllBrowsers);
                            includeDates.push(new Date(tmpDate.getTime() - tmpDate.getTimezoneOffset() * -60000));
                            //includeDates.push(deliveryDate);

                            return '';
                        });

                        var selectedDeliveryDate = localStorage.getItem('deliveryDate') || includeDates[0];
                        if (isDeliveryScreen === true) {
                            selectedDeliveryDate = includeDates[0];
                        }

                        if (isInDateArray(includeDates, (new Date(selectedDeliveryDate))) === false) {
                            selectedDeliveryDate = includeDates[0];
                        }

                        var selectedDeliveryModeCode = localStorage.getItem('deliveryModeCode') || resp.data.DlvModeReqResp.DlvMode[0].Code;
                        var selectedDeliveryMode = localStorage.getItem('deliveryModeDescription') || resp.data.DlvModeReqResp.DlvMode[0].Description;

                        localStorage.setItem('deliveryModeDescription', selectedDeliveryMode);
                        localStorage.setItem('deliveryModeCode', selectedDeliveryModeCode);
                        localStorage.setItem('deliveryDate', selectedDeliveryDate);

                        dispatch({
                            type: receiveOrderPlannerDeliveryModesType,
                            selectedDeliveryMode,
                            selectedDeliveryModeCode,
                            selectedDeliveryDate,
                            deliveryModes,
                            includeDates,
                            dateArray
                        });
                    }
                }
            });
    },

};

export const reducer = (state, action) => {
    state = state || initialState;

    if (action.type === setOrderPlannerDeliveryDateType) {

        return {
            ...state,
            selectedDeliveryDate: action.newDate
        };
    }

    if (action.type === setOrderPlannerDeliveryModeType) {

        return {
            ...state,
            selectedDeliveryMode: action.deliveryMode.Description,
            selectedDeliveryModeCode: action.deliveryMode.Code
        };
    }

    if (action.type === requestOrderPlannerUniquePOType) {

        return {
            ...state,
            isLoading: true,
            validUniquePO: action.validUniquePO
        };
    }

    if (action.type === receiveOrderPlannerUniquePOType) {

        return {
            ...state,
            isLoading: false,
            validUniquePO: action.validUniquePO
        };
    }

    if (action.type === requestOrderPlannerDeliveryModesType) {

        return {
            ...state,
            isLoading: true
        };
    }

    if (action.type === receiveOrderPlannerDeliveryDatesType) {
        return {
            ...state,
            deliveryDates: action.includeDates,
            selectedDeliveryDate: new Date(action.selectedDeliveryDate),
            isLoading: false
        };
    }

    if (action.type === receiveOrderPlannerDeliveryModesType) {
        return {
            ...state,
            deliveryModes: action.deliveryModes,
            deliveryDates: action.includeDates,
            selectedDeliveryDate: new Date(action.selectedDeliveryDate),
            selectedDeliveryModeCode: action.selectedDeliveryModeCode.replace('[Default] ', ''),
            selectedDeliveryMode: action.selectedDeliveryMode,
            isLoading: false
        };
    }

    return state;
};



// WEBPACK FOOTER //
// ./src/store/OrderPlannerDelivery.js